import { Avatar, Typography, Box } from '@mui/material';
import { Types } from '@scorenco/core';

type MemberCardProps = {
  member: Types.Teams_Team_In_Season_Has_Member;
  publicName: string;
  userRole: string;

  pictureUrl: string;
  userNumber?: number;
};

export const MemberCard = ({
  publicName,
  userRole,

  userNumber,
  pictureUrl,
  ...rest
}: MemberCardProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mt: 1,
        mb: 1,
        width: '100%',
      }}
      {...rest}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar
          alt={publicName}
          src={pictureUrl}
          sx={{ width: 40, height: 40, mr: 2 }}
        />

        <Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="h4"
              component="h4"
              sx={{
                m: 0,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {publicName}
            </Typography>

            {userNumber && (
              <Typography
                variant="h6"
                sx={{
                  m: 0,
                  fontSize: '0.8rem',
                  display: 'flex',
                  alignItems: 'center',
                  ml: '1rem',
                }}
              >
                {userNumber}
              </Typography>
            )}
          </Box>
          <Typography variant="caption" component="p">
            {userRole}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
